import { render, staticRenderFns } from "./DatasetView.vue?vue&type=template&id=60ed895a&scoped=true"
import script from "./DatasetView.vue?vue&type=script&lang=js"
export * from "./DatasetView.vue?vue&type=script&lang=js"
import style0 from "./DatasetView.vue?vue&type=style&index=0&id=60ed895a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed895a",
  null
  
)

export default component.exports